import type { ComponentProps } from 'react';

const AvatarDaughter = (props: ComponentProps<'svg'>) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M24 46C36.1503 46 46 36.1503 46 24C46 11.8497 36.1503 2 24 2C11.8497 2 2 11.8497 2 24C2 36.1503 11.8497 46 24 46Z"
      fill="#FFF2E8"
    />
    <mask
      id="mask0_208_42896"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="2"
      y="2"
      width="44"
      height="44"
    >
      <path
        d="M24 46C36.1503 46 46 36.1503 46 24C46 11.8497 36.1503 2 24 2C11.8497 2 2 11.8497 2 24C2 36.1503 11.8497 46 24 46Z"
        fill="#FFF2E8"
      />
    </mask>
    <g mask="url(#mask0_208_42896)">
      <path
        d="M25.4462 11.4692H22.9115C19.0199 11.4692 15.8652 14.624 15.8652 18.5155V26.5703C15.8652 30.4618 19.0199 33.6165 22.9115 33.6165H25.4462C29.3377 33.6165 32.4924 30.4618 32.4924 26.5703V18.5155C32.4924 14.624 29.3377 11.4692 25.4462 11.4692Z"
        fill="#FFBF9F"
      />
      <path
        d="M15.8652 22.34V18.5112C15.8652 16.6412 16.6081 14.8478 17.9303 13.5256C19.2526 12.2033 21.046 11.4604 22.9159 11.4604H25.4462C26.3719 11.4604 27.2885 11.6429 28.1437 11.9972C28.9989 12.3516 29.7758 12.871 30.4302 13.5258C31.0846 14.1806 31.6035 14.9579 31.9573 15.8133C32.3112 16.6687 32.493 17.5855 32.4924 18.5112V22.331L24.0137 14.2986L15.8652 22.34Z"
        fill="#5B1D1E"
      />
      <path
        d="M15.2121 15.5033C16.6539 15.5033 17.8227 14.3345 17.8227 12.8928C17.8227 11.451 16.6539 10.2822 15.2121 10.2822C13.7703 10.2822 12.6016 11.451 12.6016 12.8928C12.6016 14.3345 13.7703 15.5033 15.2121 15.5033Z"
        fill="#5B1D1E"
      />
      <path
        d="M33.2355 15.5033C34.6773 15.5033 35.8461 14.3345 35.8461 12.8928C35.8461 11.451 34.6773 10.2822 33.2355 10.2822C31.7938 10.2822 30.625 11.451 30.625 12.8928C30.625 14.3345 31.7938 15.5033 33.2355 15.5033Z"
        fill="#5B1D1E"
      />
      <path
        d="M14.5177 27.1549C15.9372 27.1549 17.088 26.0041 17.088 24.5845C17.088 23.165 15.9372 22.0142 14.5177 22.0142C13.0981 22.0142 11.9473 23.165 11.9473 24.5845C11.9473 26.0041 13.0981 27.1549 14.5177 27.1549Z"
        fill="#FFBF9F"
      />
      <path
        d="M33.7169 27.1549C35.1365 27.1549 36.2873 26.0041 36.2873 24.5845C36.2873 23.165 35.1365 22.0142 33.7169 22.0142C32.2973 22.0142 31.1465 23.165 31.1465 24.5845C31.1465 26.0041 32.2973 27.1549 33.7169 27.1549Z"
        fill="#FFBF9F"
      />
      <path
        d="M20.3738 24.8342C20.8445 24.8342 21.2261 24.2348 21.2261 23.4955C21.2261 22.7561 20.8445 22.1567 20.3738 22.1567C19.9031 22.1567 19.5215 22.7561 19.5215 23.4955C19.5215 24.2348 19.9031 24.8342 20.3738 24.8342Z"
        fill="#5B1D1E"
      />
      <path
        d="M28.7742 24.571C29.2449 24.571 29.6265 23.9717 29.6265 23.2323C29.6265 22.4929 29.2449 21.8936 28.7742 21.8936C28.3035 21.8936 27.9219 22.4929 27.9219 23.2323C27.9219 23.9717 28.3035 24.571 28.7742 24.571Z"
        fill="#5B1D1E"
      />
      <path
        d="M21.2107 26.7085L24.7583 29.0647C24.7583 29.0647 23.3393 31.0505 21.5766 29.8367C19.8496 28.6764 21.2107 26.7085 21.2107 26.7085Z"
        fill="white"
      />
      <path
        d="M25.2041 28.0609L24.7043 27.3201C25.0389 27.0925 25.5521 26.615 25.5968 26.3116C25.5968 26.2179 25.5968 26.1911 25.57 26.1777C25.2466 26.0183 24.8806 25.9667 24.5258 26.0304C24.4625 26.0387 24.3982 26.0334 24.3371 26.0147C24.2761 25.996 24.2198 25.9645 24.172 25.9222C24.1242 25.8799 24.086 25.8278 24.0601 25.7695C24.0341 25.7112 24.021 25.648 24.0215 25.5842V21.9785H24.914V25.1022C25.3798 25.082 25.8369 25.2327 26.1992 25.5262C26.3142 25.6416 26.4001 25.7827 26.4498 25.9379C26.4995 26.0931 26.5114 26.2579 26.4848 26.4187C26.3911 27.2308 25.4138 27.927 25.2041 28.0609Z"
        fill="#5B1D1E"
      />
      <path
        d="M14.7564 35.3032H33.8246C35.2704 35.3021 36.7024 35.5858 38.0385 36.1383C39.3747 36.6908 40.5889 37.5012 41.6117 38.5232C42.6345 39.5452 43.4459 40.7587 43.9994 42.0944C44.553 43.4301 44.838 44.8618 44.838 46.3077V70.53H3.75195L3.75195 46.3077C3.75195 44.8626 4.03659 43.4316 4.58962 42.0965C5.14264 40.7613 5.95323 39.5482 6.97509 38.5264C7.99694 37.5045 9.21007 36.6939 10.5452 36.1409C11.8803 35.5879 13.3113 35.3032 14.7564 35.3032Z"
        fill="#FFD300"
      />
      <path
        d="M30.5247 35.3032C29.872 36.4602 28.9234 37.4228 27.7762 38.0924C26.6291 38.7621 25.3244 39.1147 23.9961 39.1142C23.9961 39.1142 26.0488 42.3584 29.0521 41.3454C32.7202 40.0959 30.5247 35.3032 30.5247 35.3032Z"
        fill="#F9EEDB"
      />
      <path
        d="M17.469 35.3032C17.469 35.3032 15.2378 39.4042 18.4017 41.1044C21.7619 42.9251 23.9976 39.1008 23.9976 39.1008C22.6705 39.1031 21.3666 38.7527 20.2195 38.0854C19.0723 37.4181 18.1231 36.458 17.469 35.3032Z"
        fill="#F9EEDB"
      />
      <path
        d="M30.526 35.3032C29.873 36.46 28.9244 37.4225 27.7773 38.0922C26.6301 38.7619 25.3257 39.1148 23.9974 39.1148C22.669 39.1148 21.3646 38.7619 20.2174 38.0922C19.0703 37.4225 18.1217 36.46 17.4688 35.3032H30.526Z"
        fill="#FFBF9F"
      />
    </g>
  </svg>
);

export default AvatarDaughter;
